class KurtensSoundProof extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    this.stage = this.querySelector(".ksp__stage");
    this.video = this.querySelector(".ksp__video");
    this.frame = this.querySelector(".ksp__frame");
    this.playBtn = this.querySelector(".ksp__play");
    this.switchInput = this.querySelector(".ksp__switch-input");
    this.audioOpen = this.querySelector('.ksp__audio[data-track="open"]');
    this.audioClosed = this.querySelector('.ksp__audio[data-track="closed"]');

    if (!this.stage || !this.video) return;

    this.closed = this.stage.dataset.closed === "true";
    this.playing = false;
    this.playLabel = (this.playBtn && this.playBtn.getAttribute("aria-label")) || "Test the sound performance";

    this.applyVolumes();
    this.frame.addEventListener("click", () => this.togglePlay());
    if (this.playBtn) this.playBtn.addEventListener("click", () => this.togglePlay());
    this.video.addEventListener("ended", () => this.setPlaying(false));
    if (this.switchInput) {
      this.switchInput.addEventListener("change", () => this.setMode(this.switchInput.checked));
    }

    if ("IntersectionObserver" in window) {
      this._io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && this.playing) this.pause();
          });
        },
        { threshold: 0.15 }
      );
      this._io.observe(this);
    }
  }

  disconnectedCallback() {
    if (this._io) this._io.disconnect();
    this.pause();
  }

  get tracks() {
    return [this.audioOpen, this.audioClosed].filter(Boolean);
  }

  applyVolumes() {
    if (this.audioOpen) this.audioOpen.volume = this.closed ? 0 : 1;
    if (this.audioClosed) this.audioClosed.volume = this.closed ? 1 : 0;
  }

  setPlaying(on) {
    this.playing = on;
    this.stage.dataset.playing = on ? "true" : "false";
    if (!this.playBtn) return;
    this.playBtn.classList.toggle("is-playing", on);
    this.playBtn.setAttribute("aria-label", on ? "Pause" : this.playLabel);
  }

  togglePlay() {
    if (this.playing) this.pause();
    else this.play();
  }

  play() {
    this.applyVolumes();
    const time = this.video.currentTime || 0;
    this.tracks.forEach((audio) => {
      try {
        if (audio.readyState < 2) audio.load();
        audio.currentTime = time;
      } catch (_) {}
      const playing = audio.play();
      if (playing && playing.catch) playing.catch(() => {});
    });
    const videoPlay = this.video.play();
    if (videoPlay && videoPlay.catch) videoPlay.catch(() => {});
    this.setPlaying(true);
  }

  pause() {
    if (this.video) this.video.pause();
    this.tracks.forEach((audio) => audio.pause());
    this.setPlaying(false);
  }

  setMode(closed) {
    this.closed = closed;
    this.stage.dataset.closed = closed ? "true" : "false";
    if (this.switchInput) this.switchInput.checked = closed;
    this.applyVolumes();
  }
}

if (!customElements.get("kurtens-sound-proof")) {
  customElements.define("kurtens-sound-proof", KurtensSoundProof);
}
